import { CSSObject } from "styled-components";

//App
import Image from "../../../assets/images/Exxon_Your_Dollar_at_Work.png";
import { vfxTheme } from "../../common/VFX-UI/Theme/theme";

interface organizationStyles {
  pageContainer: CSSObject;
  sectionHeader: CSSObject;
  labelsOutsidePageHeader: CSSObject;
  pageHeaderSubtext: CSSObject;
  pageHeaderName: CSSObject;
  otherAgencyText: CSSObject;
  boldLabel: CSSObject;
  backgroundImageStyle: CSSObject;
  backButton: CSSObject;
  backButtonContainer: CSSObject;
  summaryShell: CSSObject;
  summaryHero: CSSObject;
  successIcon: CSSObject;
  summaryEyebrow: CSSObject;
  summaryTitle: CSSObject;
  summarySubtitle: CSSObject;
  summaryCard: CSSObject;
  summaryCardHeader: CSSObject;
  summaryCardTitle: CSSObject;
  amountBadge: CSSObject;
  detailsGrid: CSSObject;
  detailItem: CSSObject;
  detailLabel: CSSObject;
  detailValue: CSSObject;
  designationList: CSSObject;
  designationItem: CSSObject;
  designationName: CSSObject;
  designationAmount: CSSObject;
  summaryFooter: CSSObject;
  contactCallout: CSSObject;
  summaryNavigation: CSSObject;
  summaryBackButton: CSSObject;
}

const usePledgeStyles = (): organizationStyles => {
  
  return {
    backgroundImageStyle: {
      backgroundImage: `url(${Image})`,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "top center",
      minHeight: 500,
      maxHeight: 600,
      textAlign: "center",
    },
    pageContainer: {
      backgroundColor: vfxTheme.palette.background.default,
      borderRadius: "5px",
      boxShadow: vfxTheme.shadowTypes.container,
    },
    sectionHeader: {
      fontFamily: vfxTheme.typography.fontFamily,
      color: vfxTheme.palette.text.secondary,
      fontSize: "1.5em",
      textTransform: "none",
      marginBottom: 0,
      fontWeight: vfxTheme.fontWeights.semiBold,
      marginTop: "1rem",
    },
    labelsOutsidePageHeader: {
      fontSize: 18,
      fontWeight: 300,
      fontStyle: "none",
    },
    pageHeaderSubtext: {
      fontWeight: vfxTheme.fontWeights.light,
      marginBottom: 0,
      marginRight: vfxTheme.spaceUnits.sp01,
      fontSize: ".75em",
      fontStyle: "italic",
    },
    pageHeaderName: {
      marginBottom: 0,
      marginRight: vfxTheme.spaceUnits.sp01,
      fontSize: "1em",
      fontWeight: vfxTheme.fontWeights.medium,
    },
    otherAgencyText: {
      fontSize: "small",
      marginTop: "-13px",
      marginBottom: "-6px",
    },
    boldLabel: {
      fontWeight: vfxTheme.fontWeights.bold,
      fontSize: vfxTheme.spaceUnits.sp03,
      paddingRight: vfxTheme.spaceUnits.sp01,
      whiteSpace: "normal",
      textWrap: "nowrap",
    },
    backButton: {
      backgroundColor: vfxTheme.palette.primary.main,
      borderColor: vfxTheme.palette.primary.main,
      color: vfxTheme.palette.white,
      marginLeft: vfxTheme.spaceUnits.sp02,
      display: "flex",
      alignItems: "center",
      fontSize: "1rem",
    },
    backButtonContainer: {
      width: "min(100% - 32px, 1280px)",
      margin: "24px auto 0",
      display: "flex",
      alignItems: "center",
    },
    summaryShell: {
      width: "min(100% - 32px, 920px)",
      margin: "32px auto 64px",
      fontFamily: vfxTheme.typography.fontFamily,
      color: "#172033",
    },
    summaryHero: {
      textAlign: "center",
      marginBottom: 24,
    },
    successIcon: {
      width: 56,
      height: 56,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      backgroundColor: "#E8F7EF",
      color: "#16834B",
      marginBottom: 16,
      fontSize: 30,
    },
    summaryEyebrow: {
      margin: "0 0 8px",
      color: "#0069A6",
      fontSize: 13,
      fontWeight: 700,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
    },
    summaryTitle: {
      margin: "0 auto 10px",
      maxWidth: 720,
      fontSize: "clamp(1.75rem, 4vw, 2.5rem)",
      lineHeight: 1.15,
      fontWeight: 700,
      letterSpacing: "-0.025em",
    },
    summarySubtitle: {
      margin: "0 auto",
      maxWidth: 650,
      color: "#5D687A",
      fontSize: "1rem",
      lineHeight: 1.6,
    },
    summaryCard: {
      overflow: "hidden",
      backgroundColor: "#FFFFFF",
      border: "1px solid #E4E9F0",
      borderRadius: 16,
      boxShadow: "0 16px 40px rgba(27, 39, 64, 0.09)",
    },
    summaryCardHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 16,
      padding: "24px clamp(20px, 5vw, 36px)",
      background: "linear-gradient(135deg, #F4F9FC 0%, #F8FBFD 100%)",
      borderBottom: "1px solid #E4E9F0",
    },
    summaryCardTitle: {
      margin: 0,
      fontSize: "1.2rem",
      fontWeight: 700,
    },
    amountBadge: {
      color: "#005A8B",
      fontSize: "1.65rem",
      fontWeight: 750,
      letterSpacing: "-0.02em",
    },
    detailsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
      gap: 0,
      padding: "8px clamp(20px, 5vw, 36px) 24px",
    },
    detailItem: {
      padding: "20px 0",
      borderBottom: "1px solid #EDF0F4",
    },
    detailLabel: {
      display: "block",
      marginBottom: 6,
      color: "#6B7585",
      fontSize: 12,
      fontWeight: 700,
      letterSpacing: "0.06em",
      textTransform: "uppercase",
    },
    detailValue: {
      color: "#202A3A",
      fontSize: 15,
      fontWeight: 500,
      lineHeight: 1.5,
    },
    designationList: {
      gridColumn: "1 / -1",
      paddingTop: 20,
    },
    designationItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 16,
      padding: "12px 0px",
      marginTop: 8,
      borderRadius: 10,
      backgroundColor: "#F7F9FC",
    },
    designationName: {
      color: "#344054",
      fontSize: 14,
    },
    designationAmount: {
      color: "#172033",
      fontSize: 14,
      fontWeight: 700,
      whiteSpace: "nowrap",
    },
    contactCallout: {
      marginTop: 20,
      padding: "16px 18px",
      color: "#344054",
      backgroundColor: "#EEF7FC",
      borderLeft: "4px solid #0073A8",
      borderRadius: 8,
      fontSize: 14,
    },
    summaryNavigation: {
      width: "min(100% - 32px, 920px)",
      margin: "24px auto 0",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    summaryBackButton: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      padding: "8px 4px",
      color: "#005A8B",
      backgroundColor: "transparent",
      border: 0,
      boxShadow: "none",
      fontSize: 14,
      fontWeight: 600,
    },
    summaryFooter: {
      marginTop: 24,
      padding: "0 8px",
      color: "#6B7585",
      fontSize: 12,
      lineHeight: 1.6,
    },
  };
};

export default usePledgeStyles;

export const usePrintStyles = (): any => {
  
  return {
    header: {
      position: "fixed",
      top: 0,
      height: "80px",
      width: "100%",
    },
    container: {
      padding: vfxTheme.spaceUnits.sp00,
      width: "100%",
    },
    footer: {
      alignItems: "center",
      borderTop: "1px solid #ddd",
      bottom: "0px",
      display: "flex",
      justifyContent: "space-between",
      left: "20px",
      position: "fixed",
      paddingTop: "12px",
      right: "20px",
    },
    footerLogo: {
      height: "45px",
      width: "auto",
    },
    footerText: {
      fontSize: "small",
      textAlign: "right",
    },
  };
};
